<template>
  <section class="achievement">
    <div class="condition">
      <div class="eare">
        <span @click="deptShow = true">
          <span class="s1">{{ areaName }}</span>
          <span
            class="el-icon-caret-right el-tree-node__expand-icon expanded"
          ></span>
        </span>
        <Dept
          :visible="deptShow"
          @confirm="confirm"
          :initList="initList"
        ></Dept>
      </div>
      <div class="dateL">
        <van-cell :title="titleL" @click="dateLShow = true" />
        <van-popup
          v-model="dateLShow"
          position="bottom"
          :style="{ height: '50%' }"
        >
          <van-datetime-picker
            v-model="dateL"
            type="date"
            @confirm="onConfirmL"
            @cancel="onCancelL"
            title=""
          />
        </van-popup>
        <span
          class="el-icon-caret-right el-tree-node__expand-icon expanded"
        ></span>
      </div>
      <span>至</span>
      <div class="dateL">
        <van-cell :title="titleR" @click="dateRShow = true" />
        <van-popup
          v-model="dateRShow"
          position="bottom"
          :style="{ height: '50%' }"
        >
          <van-datetime-picker
            v-model="dateR"
            type="date"
            @confirm="onConfirmR"
            @cancel="onCancelR"
            title=""
          />
        </van-popup>
        <span
          class="el-icon-caret-right el-tree-node__expand-icon expanded"
        ></span>
      </div>
    </div>

    <div class="achievementDiv">
      <div v-show="pieData.length > 0" id="pie-box">
        <div id="pie-canvas" ref="pieCanvas"></div>
      </div>
      <div
        v-show="pieData.length == 0"
        class="tc"
        style="display: inline-block; width: 50vw"
      >
        <img width="80%" src="./assets/img/emptyData.png" />
      </div>
      <div id="pie-data">
        <div>
          <div class="pireDataItem">
            <p class="pireDataItemT">订单数(张)</p>
            <p class="pireDataItemS">{{ topData.top1 }}</p>
          </div>
          <div class="pireDataItem">
            <p class="pireDataItemT">箱数(箱)</p>
            <p class="pireDataItemS">{{ topData.top2 }}</p>
          </div>
          <div class="pireDataItem">
            <p class="pireDataItemT">金额(万元)</p>
            <p class="pireDataItemS">
              ￥{{ (Number(topData.top3) / 10000).toFixed(2) }}
            </p>
          </div>
        </div>
        <!-- <div class="pireDataItem">
          <p class="pireDataItemT">金额(元)</p>
          <p class="pireDataItemS">￥{{ Number(topData.top3) }}</p>
        </div> -->
      </div>
    </div>

    <div class="topList">
      <p class="pb15">
        <span>销售排名</span>
        <span
          v-show="pieData[0] && Number(pieData[0].show_target) == 1"
          @click="selectType"
        >
          <span>统计维度:&nbsp;{{ selectActionObj.name }}</span>
          <span
            class="el-icon-caret-right el-tree-node__expand-icon expanded"
          ></span>
        </span>
        <van-action-sheet
          v-model="vanActionShow"
          :actions="actions"
          @select="onSelect"
        />
      </p>
      <template v-if="pieData.length > 0">
        <van-row
          v-for="(item, index) in pieData"
          :key="index"
          class="topItem"
          @click="intoDetail(item.id)"
          type="flex"
          align="center"
        >
          <div
            class="topItemNum"
            v-bind:style="{ 'background-color': item.color }"
          >
            {{ index + 1 }}
          </div>
          <van-col class="topItemCol" span="11">
            <div class="topItemName">{{ item.name }}</div>
          </van-col>
          <van-col span="13" class="topItemVan">
            <div class="pt10 pb5">
              <p class="topItemP">订单数：{{ item.order_count }}</p>
              <p class="topItemP">箱数：{{ item.goods_count }}</p>
              <p class="topItemP">
                <!-- 金额(万元)：{{ (Number(item.order_amount) / 10000).toFixed(2) }} -->
                金额：{{ Number(item.order_amount) }}
              </p>
              <template v-if="Number(item.show_target) == 1">
                <p class="topItemP">毛额目标：{{ item.target }}</p>
                <p class="topItemP">毛额达成：{{ item.target_percent }} %</p>
              </template>
            </div>
          </van-col>
        </van-row>
      </template>
      <template v-else>
        <div class="tc">
          <img width="80%" src="./assets/img/emptyData.png" />
        </div>
      </template>
    </div>
  </section>
</template>
<script>
import { Dialog } from "vant";
import Dept from "@/components/dept/";
import moment from "moment";

export default {
  name: "test",
  data() {
    return {
      pieEl: null,
      dateLShow: false,
      dateRShow: false,
      dateL: new Date(),
      dateR: new Date(),
      deptShow: false,
      titleL: "选择日期 ",
      titleR: "选择日期 ",
      dataParam: {
        department_id: "",
        begin_date: "",
        end_date: "",
        order_by: "order_amount",
        order_status: 8
      },
      colorList: [
        "#FF9F7F",
        "#37A2DA",
        "#8378EA",
        "#FFDB5C",
        "#67E0E3",
        "#E690D1",
        "#E062AE",
        "#9FE6B8",
        "#96BFFF",
        "#FB7293",
        "#9D96F5",
        "#E7BCF3",
        "#32C5E9",
        "#F5AD95",
        "#F8AABD",
        "#FDE079",
        "#F5CFD8",
        "#F996AE",
        "#82E4E6",
        "#F6C1CE",
        "#F4E2E6"
      ],
      pieData: [],
      legendData: [],
      topData: {
        top1: 0,
        top2: 0,
        top3: 0
      },
      areaName: "营销区域",
      vanActionShow: false,
      actions: [
        { name: "销售金额", val: "order_amount" },
        { name: "毛额目标达成", val: "target_percent" }
      ],
      selectActionObj: { name: "销售金额", val: "order_amount" },
      initList: []
    };
  },
  components: {
    Dept
  },
  async mounted() {
    let permission = await this.$common.http({
      method: "GET",
      url: "/wxapi/permission/list_mine",
      data: {}
    });
    this.initList = [
      {
        id: permission.data.data.default_department_id,
        name: permission.data.data.default_department_name
      }
    ];
    this.dataParam.department_id = permission.data.data.default_department_id;
    this.areaName = permission.data.data.default_department_name || "营销区域";
    await this.getData();
    let option = this.getPeiOption();
    this.pieEl = this.$echarts.init(this.$refs.pieCanvas);
    this.pieEl.setOption(option);
  },
  methods: {
    selectType() {
      this.vanActionShow = true;
    },
    onSelect(item) {
      this.vanActionShow = false;
      this.selectActionObj = item;
      this.dataParam.order_by = item.val;
      this.resetPie();
    },
    intoDetail(id) {
      let param = JSON.parse(JSON.stringify(this.dataParam));
      param.department_id = id;
      if (this.pieData[0] && Number(this.pieData[0].show_target) == 1) {
        this.$router.push({
          path: "/achievementList",
          query: param
        });
      }
    },
    getPeiOption() {
      let that = this;
      return {
        legend: {
          orient: "vertical",
          left: 10,
          data: that.legendData,
          show: false
        },
        series: [
          {
            name: "销售排名",
            type: "pie",
            radius: ["30%", "85%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            data: that.pieData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },
              normal: {
                color: function(params) {
                  return params.data.color;
                }
              }
            }
          }
        ]
      };
    },
    confirm(obj, selectKeys) {
      this.deptShow = false;
      console.log(obj, selectKeys);
      this.dataParam.department_id = selectKeys[0] || "";
      this.areaName = (obj[0] && obj[0].name) || "营销区域";
      this.resetPie();
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirmL(date) {
      if (moment(date).unix() > moment(this.titleR).unix()) {
        Dialog({ message: "开始时间不能大于结束时间" });
        return;
      }
      this.dateLShow = false;
      this.titleL = moment(date).format("YYYY-MM-DD");
      this.dataParam.begin_date = moment(date).format("YYYY-MM-DD");
      this.resetPie();
    },
    onConfirmR(date) {
      if (moment(date).unix() < moment(this.titleL).unix()) {
        Dialog({ message: "结束时间不能小于开始时间" });
        return;
      }
      this.dateRShow = false;
      this.titleR = moment(date).format("YYYY-MM-DD");
      this.dataParam.end_date = moment(date).format("YYYY-MM-DD");
      this.resetPie();
    },
    onCancelL() {
      this.dateLShow = false;
    },
    onCancelR() {
      this.dateRShow = false;
    },
    async resetPie() {
      await this.getData();
      let option = this.getPeiOption();
      if (!this.pieEl) {
        this.pieEl = this.$echarts.init(this.$refs.pieCanvas);
      }
      this.pieEl.setOption(option, true);
    },
    getData() {
      return new Promise(resolve => {
        this.$common
          .http({
            mt: "post",
            url: "/wxapi/sale/lists",
            data: this.dataParam
          })
          .then(res => {
            let top1 = 0;
            let top2 = 0;
            let top3 = 0;
            res.data.data.items.forEach(element => {
              element.value = element.order_count;
              top1 += Number(element.order_count);
              top2 += Number(element.goods_count);
              top3 += Number(element.order_amount);
            });
            if (
              this.dataParam.order_by == "target_percent" &&
              res.data.data.items[0] &&
              Number(res.data.data.items[0].show_target) == 1
            ) {
              res.data.data.items.forEach(element => {
                element.value = Number(element.target_percent);
              });
            } else {
              res.data.data.items.forEach(element => {
                element.value = Number(element.order_amount);
              });
            }
            top1 = top1.toFixed(0);
            top2 = top2.toFixed(0);
            top3 = top3.toFixed(2);
            this.pieData = res.data.data.items;
            this.legendData = [];
            for (let i = 0; i < this.pieData.length; i++) {
              this.legendData.push(this.pieData[i].name);
              if (i < this.colorList.length) {
                this.pieData[i].color = this.colorList[i];
              } else {
                let ci = i % this.colorList.length;
                this.pieData[i].color = this.colorList[ci];
              }
            }
            this.topData = {
              top1: top1,
              top2: top2,
              top3: top3
            };
            resolve(res);
          });
      });
    }
  },
  async created() {
    this.titleL = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.dataParam.begin_date = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.titleR = moment().format("YYYY-MM-DD");
    this.dataParam.end_date = moment().format("YYYY-MM-DD");
  }
};
</script>
<style lang="less" scoped>
.achievement {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.condition {
  display: flex;
  font-size: 13px !important;
  padding: 10px 15px;
  align-items: center;
  box-sizing: border-box;
  .eare {
    align-items: center;
    line-height: 17px;
    > span {
      display: flex;
    }
    > span > .s1 {
      max-width: 65px;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .dateL {
    align-items: center;
    padding: 0 15px;
    display: flex;
    .van-cell {
      background: #f4f4f4;
      display: flex;
      padding: 0;
      font-size: 13px;
      line-height: 17px;
      align-items: center;
      .van-cell__title {
        flex: none;
      }
    }
    span {
      align-items: center;
      margin-left: 2px;
    }
  }
}
.achievementDiv {
  background-color: #ffffff;
  padding: 0 15px;
  box-sizing: border-box;
  #pie-box {
    display: inline-block;
    #pie-canvas {
      width: 50vw;
      height: 50vw;
    }
  }
  #pie-data {
    display: inline-block;
    width: calc(50vw - 55px);
    height: 50vw;
    vertical-align: top;
    padding-left: 10px;
    position: relative;
    box-sizing: border-box;
    > div {
      width: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .pireDataItem {
      padding: 10px 0 0 0;
      .pireDataItemT {
        font-size: 12px;
        color: rgba(27, 16, 16, 0.8);
        white-space: nowrap;
      }
      .pireDataItemS {
        font-size: 16px;
        color: #ea5412;
        white-space: nowrap;
      }
    }
  }
}
.topList {
  background-color: #ffffff;
  margin-top: 15px;
  padding: 15px;
  box-sizing: border-box;
  width: 100vw;
  > p {
    display: flex;
    align-items: center;
    > span:not(:first-child) {
      display: flex;
      align-items: center;
      font-size: 13px !important;
      padding-left: 10px;
    }
  }
  .topTitle {
    .pl22 {
      padding-left: 26px;
    }
    .topItemName {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.8);
    }
  }
  .topItem {
    margin-bottom: 10px;
    background: rgba(234, 84, 19, 0.03);
    border-radius: 2px;
    display: flex;
    position: relative;
    .topItemVan {
      display: flex;
      align-items: center;
    }
    .topItemP {
      font-size: 13px;
      color: #4f4a4c;
      letter-spacing: 0;
      line-height: 14px;
      padding-bottom: 7px;
    }
    .topItemCol {
      position: relative;
      margin-top: 24px;
    }
    .topItemNum {
      background: rgba(252, 208, 76, 0.8);
      border-radius: 4px 0 12px 0;
      width: 48px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      color: #ffffff;
      font-size: 17px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .topItemName {
      font-size: 17px;
      color: #ea5413;
      letter-spacing: 0;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: left;
      padding: 5px 10px 5px 5px;
      box-sizing: border-box;
      padding-left: 5px;
    }
    .c33 {
      color: #333333;
    }
  }
}
</style>
